import Vue from 'vue'
import AppSe from './App.vue'

import VueRouter from 'vue-router';
import vuetify from './plugins/vuetify';
import VueResource from "vue-resource"

// import main2 from 'main2';
// import './assets/fb.js'
Vue.use(VueResource);
const Foo = { template: '<div>foo</div>' }
const routes = [
  { path: '/', component: Foo }
]

 

Vue.use(VueRouter);

const router = new VueRouter({
  routes // short for `routes: routes`
})
Vue.config.productionTip = false
new Vue({
  router,
  vuetify,
  render: h => h(AppSe)
}).$mount('#app')
